import { useMemo } from "react"
import { useDate } from "src/shared/hooks/useDate"
import { useCountdown } from "src/shared/hooks/useCountdown"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import { useCurrentDate } from "src/shared/providers/CurrentdateProvider"
import { VENTA_EN_LINEA_DURATION_MS } from "../constants/ventaEnLinea"

// Cuenta desde el cambio de estado hasta la fecha_condensada de la última renta, con el mismo formato que la card de ocupada.
// Sin dateStatusChanged la cuenta queda fija en el tiempo completo; sin fecha fin se usa la duración por defecto
export const useVentaEnLineaCountdown = (dateStatusChanged?: string, dateEnd?: string) => {
    const [now] = useCurrentDate()
    const { UTCStringToLocalDate } = useDate()
    const startDate = useMemo(
        () => (dateStatusChanged ? UTCStringToLocalDate(dateStatusChanged) : undefined),
        [dateStatusChanged]
    )
    const endDate = useMemo(() => (dateEnd ? UTCStringToLocalDate(dateEnd) : undefined), [dateEnd])
    const durationMs = useMemo(() => {
        if (!startDate || !endDate) {
            return VENTA_EN_LINEA_DURATION_MS
        }
        return Math.max(0, endDate.getTime() - startDate.getTime())
    }, [startDate, endDate])
    const countdown = useCountdown(startDate, durationMs)

    // Diferencia absoluta contra la fecha fin: cuenta regresiva antes y tiempo excedido después
    const [elapsedTime] = useElapsedTime(endDate || now, "noche")
    const isExceeded = !!endDate && now > endDate

    return {
        ...countdown,
        // Se pasó la fecha fin sin hacer check in: la venta en línea queda como no show
        isExceeded,
        timeLeft: endDate ? `${isExceeded ? "+" : ""}${elapsedTime}` : countdown.timeLeft,
        // Porcentaje transcurrido: la barra empieza vacía y se llena conforme se acerca la fecha fin
        percentElapsed: isExceeded
            ? "100%"
            : `${durationMs ? ((durationMs - countdown.remainingMs) / durationMs) * 100 : 0}%`,
    }
}
